import { Card } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { Skeleton } from '@/components/ui/skeleton';

const AppCardSkeleton = () => {
  return (
    <Card data-testid="app-card-skeleton" className="relative overflow-hidden min-h-59 h-full flex">
      <div className="relative p-4 flex flex-col justify-between gap-2 grow">
        <div className="flex items-start justify-between gap-2">
          <div data-testid="app-card-skeleton-name" className="space-y-1.5">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-3 w-20" />
          </div>
          <Skeleton data-testid="app-card-skeleton-avatar" className="size-13 shrink-0 rounded-full" />
        </div>
        <div data-testid="app-card-skeleton-tags" className="flex gap-1">
          <Skeleton className="h-5 w-16 rounded-full" />
          <Skeleton className="h-5 w-20 rounded-full" />
        </div>
        <div className="space-y-4">
          <Separator data-testid="app-card-skeleton-divider" />
          <div data-testid="app-card-skeleton-footer" className="flex items-center gap-2">
            <Skeleton className="size-7 rounded-md" />
            <Skeleton className="size-7 rounded-md" />
            <Skeleton className="size-7 rounded-md" />
          </div>
        </div>
      </div>
    </Card>
  );
};

export { AppCardSkeleton };
